import { useState } from "react";
import { FileText, Loader2, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { DateField } from "@/components/DateField";
import { api, download, errMsg, money } from "@/lib/api";

export const DecisionTal = ({ l, onDone }) => {
  const h = l.hausse, dec = h.decision;
  const [loyer, setLoyer] = useState("");
  const [effet, setEffet] = useState(h.a_partir_de);
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [busy, setBusy] = useState(false);
  const appel = async (fn, msg) => {
    setBusy(true);
    try { await fn(); toast.success(msg); onDone(); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  if (dec) {
    return (
      <div className="flex flex-wrap items-center gap-2 text-xs text-emerald-800" data-testid="decision-tal-resume">
        Décision du TAL du {dec.date_decision} : loyer fixé à <b>{money(dec.loyer)}</b> dès le {dec.date_effet}.
        <Button size="sm" variant="outline" className="h-7 text-xs" onClick={() => download(`/locataires/${l.id}/lettre-regularisation`, {}, "regularisation-loyer.pdf").catch((e) => toast.error(errMsg(e)))} data-testid="decision-tal-lettre"><FileText className="h-3 w-3 mr-1" />Lettre de régularisation (PDF)</Button>
        <Button size="sm" variant="ghost" className="h-7 text-xs text-red-600" disabled={busy} onClick={() => appel(() => api.delete(`/locataires/${l.id}/decision-tal`), "Décision retirée")} data-testid="decision-tal-annuler"><Trash2 className="h-3 w-3 mr-1" />Retirer</Button>
      </div>
    );
  }
  const n = Number(String(loyer).replace(",", "."));
  return (
    <div className="space-y-1" data-testid="decision-tal">
      <p className="text-xs font-semibold">Décision du TAL</p>
      <div className="flex flex-wrap items-end gap-2 text-[11px] text-slate-500">
        <label className="space-y-0.5"><span>Loyer fixé ($ / mois)</span><Input value={loyer} onChange={(e) => setLoyer(e.target.value)} inputMode="decimal" className="h-8 w-28 text-xs text-right font-mono" data-testid="decision-tal-loyer" /></label>
        <label className="space-y-0.5"><span>En vigueur dès le</span><DateField value={effet} onChange={setEffet} className="h-8 w-40 text-xs" data-testid="decision-tal-effet" /></label>
        <label className="space-y-0.5"><span>Date de la décision</span><DateField value={date} onChange={setDate} className="h-8 w-40 text-xs" data-testid="decision-tal-date" /></label>
        <Button size="sm" className="h-8 text-xs bg-emerald-700 hover:bg-emerald-800" disabled={!n || !effet || !date || busy}
          onClick={() => appel(() => api.post(`/locataires/${l.id}/decision-tal`, { loyer: n, date_effet: effet, date_decision: date }), "Loyer fixé par le TAL enregistré")} data-testid="decision-tal-enregistrer">
          {busy && <Loader2 className="h-3.5 w-3.5 mr-1 animate-spin" />}Enregistrer</Button>
      </div>
      <p className="text-[11px] text-slate-500">Le loyer fixé est suivi dans les loyers manquants dès sa date d'effet, y compris pour les mois déjà passés (écart rétroactif à régulariser).</p>
    </div>
  );
};
